<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="search-name">仓库</div>
                    <el-select v-model="searchData.WHId" :loading="loading" class="search-item" size="small" filterable clearable remote
                        @visible-change="warehouseVisibleChange($event)">
                        <el-option v-for="optionItem in WarehouseList" :label="optionItem.WarehouseName" :value="optionItem.WarehouseId"
                            v-bind:key="optionItem.index"><span style="float: left">{{ optionItem.WarehouseName }}</span>
                            <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span></el-option>
                    </el-select>
                    <div class="search-name">统计时间</div>
                    <el-date-picker class="search-name" v-model="searchData.Date" size="small" type="date" placeholder="选择日期"></el-date-picker>
                    <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                    <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                </div>
            </div>
            <div class="table-ctn">
                <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%" show-summary :summary-method="getSummaries"
                    :default-sort="{ prop: 'TotalCost', order: 'descending' }">
                    <el-table-column show-overflow-tooltip width="60px" type="index" :index="indexMethod" label="排名"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable width="160" prop="StoName" label="仓库"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable width="120" prop="TotalCate" label="废品种类"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable width="130" prop="TotalCount" label="废品总数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable width="140" prop="TotalCost" label="废品总成本"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable width="120" prop="LTotalCount" label="标签总数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable width="130" prop="LGTotalCount" label="标签废品总数"></el-table-column>
                    <el-table-column show-overflow-tooltip sortable width="150" prop="LGTotalCost" label="标签废品总成本"></el-table-column>
                    <el-table-column show-overflow-tooltip width="120" prop="StatTime" label="统计时间"></el-table-column>
                    <el-table-column label="" width="98px">
                        <template slot-scope="scope">
                            <div class="ops-ctn">
                                <el-button title="查看废品数据" size="mini" type="text" @click="showWasteDatas(scope.row)">查看废品数据</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="废品商品明细" :visible.sync="detailsVisible" width="1300px">
            <div class="dialog-content" v-if="detailsVisible">
                <wasteDatas ref="wasteGoodsDetails" :WHId="whId"></wasteDatas>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import wasteDatas from '@/components/business/goods/wasteGoodsDetails';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: 'whStat',
    components: {
        breadcrumb,
        wasteDatas
    },
    data() {
        return {
            loading: false,
            detailsVisible:false,
            whId:'',
            dateTimes: [],
            searchData: {
                WHId: '',
                Date: ''
            },
            tableData: [],
            tableDataLength: 0,
            WarehouseList: []
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);

        //当前设定的日期时间
        let d = new Date();
        let year1, month1, day1;
        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
        let date1 = new Date(year1, month1, day1 - 1, 0);
        this.dateTimes.push(date1);

        this.searchData.Date = date1;

        this.getTableData();
    },
    methods: {
        // 重置表单
        resetSearch() {
            this.searchData = {
                WHId: '',
                Date: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        // 获取数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/DataStatistics/WHWasteStatistics',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        this.noData = true;
                        return;
                    }
                    this.noData = false;
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => { });
        },
        handleSearch() {
            this.getTableData();
        },
        indexMethod(index) {
            return index + 1;
        },
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.WarehouseList = data;
            });
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.WarehouseList.length <= 1) that.getWarehouse();
            }
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                } else if (index == 1 ||index == 8) {
                    sums[index] = '';
                } else {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        if (index == 4 || index == 7) sums[index] = sums[index].toFixed(2);
                    }
                }
            });

            return sums;
        },
        showWasteDatas(row){
            if(row.StoId){
                this.whId = row.StoId;
                this.detailsVisible = true;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;

    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 20%;
        border-right: 1px solid @border4Color;

        >p:nth-child(1) {
            margin-bottom: 5px;
        }

        .el-button {
            padding: 0;
        }
    }
}

.ops-ctn {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .image-sup {
        width: 22px;
        height: 22px;
        margin-right: 10px;
    }

    .image-cus {
        width: 22px;
        height: 22px;
    }
}
</style>
